module.exports = __webpack_public_path__ + "static/img/m2.861ed4c.png";


//////////////////
// WEBPACK FOOTER
// ./static/m2.png
// module id = v+Sx
// module chunks = 1